export default __webpack_public_path__ + "static/media/CNo.90-2.4944e6f0.jpg";